import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import { useUserStore } from './stores/user'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)

app.mount('#app')

// Initialize user store after app is mounted
const userStore = useUserStore()
userStore.initializeLanguage()
userStore.initializeUser().catch(error => {
  console.error('Failed to initialize user:', error)
})
